import * as Yup from 'yup';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useSignupLocationsFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();

  const formSchema = Yup.object().shape({
    signupLocations: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSearchChange = (currentValue) =>
    getFilterOptions({
      facet: 'signup_locations',
      query: currentValue,
      sharedList,
      orderBy,
    }).then((res) => res.data);

  const onSubmit = ({ signupLocations }) => {
    setFilters({ signupLocations });
  };

  return {
    formSchema,
    onSearchChange,
    onSubmit,
  };
};
